import { render, staticRenderFns } from "./transferredFolder.vue?vue&type=template&id=02ce1c2a&scoped=true&"
import script from "./transferredFolder.vue?vue&type=script&lang=js&"
export * from "./transferredFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ce1c2a",
  null
  
)

export default component.exports